import api from "../axios_service.js";

export async function fetchCalendarioColaborador(filtros) {
  const response = await api.get(
    `/calendario-atividade${filtros ? filtros : ""}`
  );
  return response.data.result;
}
